module.exports = __webpack_public_path__ + "img/empreendimento-logo-18.f027608f.png";